import { render, staticRenderFns } from "./CianElementNameTableColumn.vue?vue&type=template&id=71b130ae&scoped=true"
import script from "./CianElementNameTableColumn.vue?vue&type=script&lang=js"
export * from "./CianElementNameTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CianElementNameTableColumn.vue?vue&type=style&index=0&id=71b130ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b130ae",
  null
  
)

export default component.exports